import { API_BASE_URL as BASE_URL } from './apiConfig';

const ADMIN_API_BASE_URL = `${BASE_URL}/admin`;

export interface AdminSendOTPRequest {
  email: string;
}

export interface AdminVerifyOTPRequest {
  email: string;
  otp: string;
  sessionId: string;
}

export interface AdminAuthResponse {
  success: boolean;
  message: string;
  sessionId?: string;
  maskedEmail?: string;
  token?: string;
  admin?: {
    id: number;
    name: string;
    phone: string;
    role: string;
    email: string;
  };
}

class AdminAuthService {
  private async makeRequest(endpoint: string, data: any): Promise<AdminAuthResponse> {
    try {
      const response = await fetch(`${ADMIN_API_BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();
      
      if (!response.ok) {
        throw new Error(result.message || `HTTP error! status: ${response.status}`);
      }

      return result;
    } catch (error) {
      console.error(`Admin Auth API Error (${endpoint}):`, error);
      throw error;
    }
  }

  async sendAdminOTP(data: AdminSendOTPRequest): Promise<AdminAuthResponse> {
    return this.makeRequest('/send-otp', data);
  }

  async verifyAdminOTP(data: AdminVerifyOTPRequest): Promise<AdminAuthResponse> {
    return this.makeRequest('/verify-otp', data);
  }
}

export default new AdminAuthService();

